module.exports = __webpack_public_path__ + "static/media/juice.d562fda7.jpg";